export class deliveredUrl {
    ARCHIVE_SIGNATURE_URL = "sig/v1/delivered-signature/archive";
    DELETE_SIGNATURES_URL = "sig/v1/delivered-signature/";
    GET_DELIVERED_SIGNATURES_URL = "sig/v1/delivered-signature/all[?ClientId][&ClientName][&subject][&SentBy][&DocumentName][&DocumentType][&TaxYear][&DeliveredDate][&Recipient][&signatureStatus][&ExpiryDate][&LastReminderDate][&SortBy][&SortOrder][&PageSize][&PageNumber]";
    RESEND_ACCESS_LINK_URL = "sig/v1/delivered-signature/resend-access-link";
    SEND_REMINDER_URL = "sig/v1/delivered-signature/send-reminder";
    GET_SINGER_DETAIL_URL = "sig/v1/delivered-signature/{documentId}/signer-details";
    GET_ACCESS_LINK_URL = "sig/v1/delivered-signature/access-link/{documentId}"
}